export default __webpack_public_path__ + "static/media/red-bg.1c466fc5.png";